module.exports = __webpack_public_path__ + "img/MAGNA_background.5da64308.png";